import { render } from "./BaseCard.vue?vue&type=template&id=89b5a022&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=89b5a022&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\estimate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89b5a022"]])

export default __exports__